"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cbafd914c{padding:1.25rem 1.5625rem;border-radius:var(--border-radius-def);background:#fff}.cb246f3bf{display:block}.ca153c920{height:1.25rem}.c5d4f7467{overflow:hidden;transition:max-height .2s ease-out}");
var styles = {
  root: 'cbafd914c',
  head: 'cb246f3bf',
  margin: 'ca153c920',
  content: 'c5d4f7467'
};

var Collapse = function Collapse(props) {
  var head = props.head,
      children = props.children,
      openable = props.openable,
      open = props.open,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var el = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    el.current.style.maxHeight = openable ? "".concat(open ? el.current.scrollHeight : 0, "px") : 'initial';
  }, [open, openable, children]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.head
  }, head), /*#__PURE__*/_react.default.createElement("div", {
    ref: el,
    className: cn.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.margin
  }), children));
};

exports.Collapse = Collapse;
Collapse.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  head: _propTypes.node.isRequired,
  openable: _propTypes.bool,
  open: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Collapse.defaultProps = {
  openable: false,
  open: false,
  classes: {}
};